import { Route, Routes } from "react-router-dom";
import { NotFound } from "src/routes/NotFound";
import {
  EstimateExportPdf,
  HomeownerChangeOrderPdf,
  ProjectItemScopeOfWorkPdf,
  ScheduleExportPdf,
  ScheduleOfValuesPdf,
} from "src/routes/pdfs";
import { DevelopmentCommitmentPdf } from "src/routes/pdfs/DevelopmentCommitmentPdf";
import { ToDosPdf } from "src/routes/pdfs/ToDosPdf";
import { TradeScopeOfWorkPdf } from "src/routes/pdfs/TradeScopeOfWorkPdf";
import { TradeSpecificAgreement } from "src/routes/pdfs/TradeSpecificAgreement";
import { LotSequenceSheetPdf } from "src/routes/pdfs/lot-sequence-sheet/LotSequenceSheetPdf";
import {
  bidCommitmentChangeOrderPdfPath,
  bidCommitmentPdfPath,
  billPdfPath,
  commitmentChangeOrderPdfPath,
  commitmentPdfPath,
  developmentCommitmentPdfPath,
  developmentContractPdfPath,
  estimateExportPath,
  finishScheduleVisualModePdfPath,
  homeownerChangeOrderPath,
  invoicePandaDocPdfPath,
  invoicePdfPath,
  lienWaiverPdfPath,
  lotSequenceSheetPdfPath,
  lotSummaryDetailsPdfPath,
  projectFinishSchedulePdfPath,
  projectFinishScheduleVisualModePdfPath,
  projectItemScopeOfWorkPath,
  scheduleExportPath,
  scheduleOfValuesPath,
  toDoPdfPath,
  tradeScopeOfWorkPath,
  tradeSpecificAgreementPath,
  tradesPunchlistPdfPath,
} from "src/routes/routesDef";
import { BillPdf } from "./routes/pdfs/BillPdf/BillPdf";
import { CommitmentOrChangeOrderPdf } from "./routes/pdfs/CommitmentOrChangeOrderPdf/CommitmentOrChangeOrderPdf";
import { DevelopmentContractPdf } from "./routes/pdfs/DevelopmentContractPdf/DevelopmentContractPdf";
import { FinishScheduleVisualModePdf } from "./routes/pdfs/FinishSchedulePdf/FinishScheduleVisualModePdf";
import { InvoicePandaDocPdf } from "./routes/pdfs/InvoicePdf/InvoicePandaDocPdf";
import { InvoicePdf } from "./routes/pdfs/InvoicePdf/InvoicePdf";
import { LienWaiverRouter } from "./routes/pdfs/LienWaiverPdf/LienWaiverRouter";
import { ProjectFinishSchedulePdf } from "./routes/pdfs/ProjectFinishSchedulePdf/ProjectFinishSchedulePdf";
import { ProjectFinishScheduleVisualModePdf } from "./routes/pdfs/ProjectFinishSchedulePdf/ProjectFinishScheduleVisualModePdf";
import { TradesPunchlistPdf } from "./routes/pdfs/TradesPuchlistPdf/TradesPunchlistPdf";
import { LotSummaryDetailsPdf } from "./routes/pdfs/lot-summary-details/LotSummaryDetailsPdf";

/**
 * Routes for our "rendering PDFs via React" approach.
 *
 * Note that these are not wrapped in AuthenticatedRoute because when loaded
 * by the "save HTML as PDF" headless browser, we don't have Amplify-managed
 * auth in place, we just use a bump `Authorization` header that the backend
 * understands.
 */
export function PdfRoutes() {
  return (
    <Routes>
      <Route path={scheduleOfValuesPath} element={<ScheduleOfValuesPdf />} />
      <Route path={projectItemScopeOfWorkPath} element={<ProjectItemScopeOfWorkPdf />} />
      <Route path={tradeScopeOfWorkPath} element={<TradeScopeOfWorkPdf />} />
      <Route path={homeownerChangeOrderPath} element={<HomeownerChangeOrderPdf />} />
      <Route path={estimateExportPath} element={<EstimateExportPdf />} />
      <Route path={scheduleExportPath} element={<ScheduleExportPdf />} />
      <Route path={`${tradeSpecificAgreementPath}/*`} element={<TradeSpecificAgreement />} />
      <Route path={`${developmentCommitmentPdfPath}/*`} element={<DevelopmentCommitmentPdf />} />
      <Route path={`${commitmentPdfPath}/*`} element={<CommitmentOrChangeOrderPdf />} />
      <Route path={`${commitmentChangeOrderPdfPath}/*`} element={<CommitmentOrChangeOrderPdf />} />
      <Route path={bidCommitmentPdfPath} element={<CommitmentOrChangeOrderPdf />} />
      <Route path={bidCommitmentChangeOrderPdfPath} element={<CommitmentOrChangeOrderPdf />} />
      <Route path={toDoPdfPath} element={<ToDosPdf />} />
      <Route path={developmentContractPdfPath} element={<DevelopmentContractPdf />} />
      <Route path={lotSequenceSheetPdfPath} element={<LotSequenceSheetPdf />} />
      <Route path={lotSummaryDetailsPdfPath} element={<LotSummaryDetailsPdf />} />
      <Route path={billPdfPath} element={<BillPdf />} />
      <Route path={invoicePandaDocPdfPath} element={<InvoicePandaDocPdf />} />
      <Route path={invoicePdfPath} element={<InvoicePdf />} />
      <Route path={lienWaiverPdfPath} element={<LienWaiverRouter />} />
      <Route path={finishScheduleVisualModePdfPath} element={<FinishScheduleVisualModePdf />} />
      <Route path={projectFinishScheduleVisualModePdfPath} element={<ProjectFinishScheduleVisualModePdf />} />
      <Route path={projectFinishSchedulePdfPath} element={<ProjectFinishSchedulePdf />} />
      <Route path={tradesPunchlistPdfPath} element={<TradesPunchlistPdf />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
